import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { mapboxConfig } from '../../mapbox/config';

import './Map.scoped.scss';

import Filters from '../filters/Filters';
import VenueInformation from './modals/VenueInformation';

mapboxgl.accessToken = mapboxConfig.accessToken;

function MapComponent({ locations }) {
    const mapContainerRef = useRef(null);
    const [map, setMap] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [currentVenue, setCurrentVenue] = useState(null);
    const [filters, setFilters] = useState({
        tag: {
            ARI: true,  // Arizona Cardinals
            ATL: true,  // Atlanta Falcons
            BAL: true,  // Baltimore Ravens
            BUF: true,  // Buffalo Bills
            CAR: true,  // Carolina Panthers
            CHI: true,  // Chicago Bears
            CIN: true,  // Cincinnati Bengals
            CLE: true,  // Cleveland Browns
            DAL: true,  // Dallas Cowboys
            DEN: true,  // Denver Broncos
            DET: true,  // Detroit Lions
            GB: true,   // Green Bay Packers
            HOU: true,  // Houston Texans
            IND: true,  // Indianapolis Colts
            JAX: true,  // Jacksonville Jaguars
            KC: true,   // Kansas City Chiefs
            LAC: true,  // Los Angeles Chargers
            LA: true,  // Los Angeles Rams
            LV: true,   // Las Vegas Raiders
            MIA: true,  // Miami Dolphins
            MIN: true,  // Minnesota Vikings
            NE: true,   // New England Patriots
            NO: true,   // New Orleans Saints
            NYG: true,  // New York Giants
            NYJ: true,  // New York Jets
            PHI: true,  // Philadelphia Eagles
            PIT: true,  // Pittsburgh Steelers
            SEA: true,  // Seattle Seahawks
            SF: true,   // San Francisco 49ers
            TB: true,   // Tampa Bay Buccaneers
            TEN: true,  // Tennessee Titans
            WFT: true   // Washington Football Team
        },
        venueType: {
            stadium: false,
            team: true,
            sports: false
        }
    });
    const markersRef = useRef([]);

    const filteredLocations = locations.filter(location => 
        filters.tag[location.tag] && filters.venueType[location.venueType]
    );

    useEffect(() => {
        if (!map) return;

        // Remove all markers
        markersRef.current.forEach(marker => marker.remove());
        markersRef.current = [];

        // Add new filtered markers
        filteredLocations.forEach(location => {
            const marker = new mapboxgl.Marker({color:'#7f7fd5'})
                .setLngLat([location.longitude, location.latitude])
                .addTo(map);

            marker.getElement().addEventListener('click', () => {
                setCurrentVenue(location);
                setShowModal(true);
            });

            markersRef.current.push(marker);
        });
    }, [map, filteredLocations]);

    useEffect(() => {
        const initializeMap = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/dark-v11',
            center: [-95.7129, 37.0902],
            zoom: 4
        });
        
        initializeMap.on('load', () => {
            setMap(initializeMap);
        });

        return () => initializeMap.remove();
    }, [locations]);

    return (
        <div>
            
            <Filters filters={filters} setFilters={setFilters} map={map}></Filters>
            <div className='main-map' ref={mapContainerRef} />
            <VenueInformation showModal={showModal} setShowModal={setShowModal} currentVenue={currentVenue} />
        </div>
    );
}

export default MapComponent;